import { defineMessages } from 'react-intl';

export default defineMessages({
  usernameError: {
    id: 'accountSignin.signinColumn.usernameError',
    defaultMessage: 'Enter an email/username.',
    description: 'Error displayed when a username is not provided',
  },
  usernameLabel: {
    defaultMessage: 'Username or email address',
    description: 'Label for username input.',
    id: 'accountSignin.signinColumn.usernameLabel',
  },
  passwordError: {
    id: 'accountSignin.signinColumn.passwordError',
    defaultMessage: 'Enter a password.',
    description: 'Error displayed when a password is not provided',
  },
  updatedTermsOfUse: {
    defaultMessage: 'View our new {termsOfUseLink}.',
    description: 'Message directing user that terms of use have changed',
    id: 'accountSignin.signinColumn.updatedTermsOfUse',
  },
});
